import {Component, Input, OnInit} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

import {FieldConfig, FieldOption} from '../../../models/form-config.model';
import {CustomSelect, SelectOption} from '../../../../../widgets/custom-select/custom-select';

/**
 * DropdownField — wrapper di CustomSelect.
 *
 * Poiché CustomSelect implementa ControlValueAccessor (tramite il formControl passato come input),
 * è sufficiente passargli [control] e Angular gestirà automaticamente
 * la sincronizzazione bidirezionale con il FormControl dell'engine.
 *
 * La normalizzazione delle opzioni (string | number | FieldOption → SelectOption[])
 * avviene qui per mantenere CustomSelect invariato.
 */
@Component({
  selector: 'app-dropdown-field',
  standalone: true,
  imports: [ReactiveFormsModule, CustomSelect],
  template: `
    <app-custom-select
      [control]="control"
      [label]="field.label"
      [options]="normalizedOptions"
      [required]="field.required ?? false"
      [selectId]="field.key"
      [placeholder]="field.placeholder ?? ''"
    />
  `,
  styles: [`
    :host { display: block; width: 100%; }
  `],
})
export class DropdownFieldComponent implements OnInit {
  @Input({required: true}) field!: FieldConfig;
  @Input({required: true}) control!: FormControl;

  normalizedOptions: SelectOption[] = [];

  ngOnInit(): void {
    this.normalizedOptions = this.normalizeOptions();
  }

  /**
   * Normalizza le opzioni al formato SelectOption[] accettato da CustomSelect.
   * Supporta: string[], number[], FieldOption[].
   */
  private normalizeOptions(): SelectOption[] {
    if (!this.field.options?.length) return [];

    const first = this.field.options[0];

    if (typeof first === 'string' || typeof first === 'number') {
      return (this.field.options as (string | number)[]).map(val => ({
        label: String(val),
        value: val
      }));
    }

    // FieldOption[]
    return (this.field.options as FieldOption[]).map(o => ({
      label: o.label,
      value: o.value
    }));
  }
}
